export { BarComponent } from './bar.component';
export { ProgressDirective } from './progress.directive';
export { ProgressbarComponent } from './progressbar.component';
export { ProgressbarModule } from './progressbar.module';
export { ProgressbarConfig } from './progressbar.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// F:/Agent/vsts-agent1/_work/76/s/CIA.ClientSide/~/ngx-bootstrap/progressbar/index.js
// module id = ../../../../ngx-bootstrap/progressbar/index.js
// module chunks = 4